import { createIcon } from '@chakra-ui/react/icon'

const HeartIcon = createIcon({
  displayName: 'HeartIcon',
  viewBox: '0 0 20 18',
  path: [
    <path
      d="m10.723 1.66-.544.538-.544-.539A5.353 5.353 0 0 0 7.892.493 5.393 5.393 0 0 0 2.023 1.66 5.298 5.298 0 0 0 .845 3.387a5.258 5.258 0 0 0 1.178 5.816l8.156 8.083 8.158-8.083a5.298 5.298 0 0 0 1.177-1.727 5.258 5.258 0 0 0-1.177-5.817A5.355 5.355 0 0 0 16.593.493a5.394 5.394 0 0 0-5.87 1.166Z"
      fill="currentColor"
    />,
  ],
})

export default HeartIcon
